import { AccordionItem } from 'Components/Accordion/AccordionItem/AccordionItem';
import { AccordionToggle } from 'Components/Accordion/AccordionToggle/AccordionToggle';

import styles from './InherentRiskQuestionnaireConfigurationRow.module.css';

export interface InherentRiskQuestionnaireConfigurationRowProps {
    eventKey?: string;
    level: 0 | 1 | 2 | 3;
    accessibilityTitle?: string;
    children?: React.ReactNode;
}

export const InherentRiskQuestionnaireConfigurationRow: React.FC<InherentRiskQuestionnaireConfigurationRowProps> = ({ eventKey, level, accessibilityTitle, children }: InherentRiskQuestionnaireConfigurationRowProps) => {
    const getStyleClassArrow = (): string => {
        switch (level) {
            case 0:
                return styles.inlineStylesLevel0;
            case 1:
                return styles.inlineStylesLevel1;
            case 2:
                return styles.inlineStylesLevel2;
            case 3:
                return styles.inlineStylesLevel3;
            default:
                return '';
        }
    };

    const getStyleClassNoArrow = (): string => {
        switch (level) {
            case 0:
                return styles.inlineStylesNoArrowLevel0;
            case 1:
                return styles.inlineStylesNoArrowLevel1;
            case 2:
                return styles.inlineStylesNoArrowLevel2;
            case 3:
                return styles.inlineStylesNoArrowLevel3;
            default:
                return '';
        }
    };

    if (eventKey && accessibilityTitle) {
        return (
            <AccordionItem eventKey={eventKey}>
                <div className={`${styles.row} ${getStyleClassArrow()}`}>
                    <AccordionToggle eventKey={eventKey} ariaLabelSuffix={accessibilityTitle} />
                    {children}
                </div>
                <hr className={styles.hrModifier} />
            </AccordionItem>
        );
    }

    return (
        <>
            <div className={`${styles.row} ${getStyleClassNoArrow()}`}>{children}</div>
            <hr className={styles.hrModifier} />
        </>
    );
};
